import React, { FC, SVGProps } from 'react';

export const NewsweekLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 236 40"
    width={236}
    height={40}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={286}
        height={74}
        x={-25}
        y={-16}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M260.803-15.143H-24.54v73.131h285.343v-73.13Z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#333"
          d="M37.427 8.837h-3.243v28.27h-6.08L13.312 17.855v12.97h3.242v6.282H2.875v-6.282h3.242V8.837H2.875V2.555H13.31l13.78 17.934V8.837H23.85V2.555h13.679c-.101 0-.101 6.282-.101 6.282Zm21.683 16.11v1.622H44.013c-.405 4.864 1.418 6.282 4.154 6.282 2.33 0 4.053-1.52 4.053-3.951h6.485c-.101 4.255-2.33 9.119-10.943 9.119-8.511 0-12.463-6.181-12.463-13.071 0-6.181 4.053-12.767 12.362-12.767 7.903 0 11.45 5.573 11.45 12.767Zm37.288-6.18h-2.23l-5.572 18.745H81.2l-3.445-10.234-3.14 10.234h-7.499l-6.18-18.745h-2.23v-6.384h13.071v6.384h-3.242l3.445 9.93 4.458-16.314h4.053l5.472 16.314 2.938-9.93h-3.242v-6.384h10.943c-.203 0-.203 6.384-.203 6.384Zm9.221.203c0 .912.709 1.52 3.141 2.229l3.546 1.114c3.243 1.115 7.195 3.445 7.195 7.904 0 5.167-3.851 7.7-8.715 7.7-3.85 0-6.788-1.823-7.598-2.735v2.128h-6.385v-8.715h6.283c.202 2.838 2.735 4.358 4.965 4.358 1.824 0 2.735-.811 2.735-1.723 0-1.115-.708-1.824-3.85-2.837l-3.141-1.013c-3.141-1.014-6.687-3.344-6.687-7.6 0-5.167 4.56-7.7 8.41-7.7 4.053 0 5.978 1.114 6.991 2.229v-1.926h6.384v7.802h-6.587c-.101-2.127-2.127-3.04-4.255-3.04-1.723.102-2.432.811-2.432 1.825Zm52.081-.203h-2.229l-5.573 18.745h-7.396l-3.446-10.234-3.141 10.234h-7.497l-6.182-18.745h-2.228v-6.384h13.07v6.384h-3.242l3.445 9.93 4.357-16.314h4.053l5.472 16.314 2.938-9.93h-3.343v-6.384H157.7v6.384Zm23.103 6.18v1.622h-14.996c-.406 4.864 1.418 6.282 4.154 6.282 2.331 0 4.053-1.52 4.053-3.951h6.485c-.101 4.255-2.432 9.119-10.944 9.119-8.612 0-12.564-6.181-12.564-13.071 0-6.181 4.154-12.767 12.464-12.767 7.903 0 11.348 5.471 11.348 12.767Zm24.724-.1v1.62H190.53c-.405 4.864 1.419 6.283 4.155 6.283 2.33 0 4.052-1.52 4.052-3.952h6.485c-.1 4.256-2.432 9.12-10.943 9.12-8.612 0-12.564-6.181-12.564-13.072 0-6.18 4.154-12.767 12.463-12.767 7.904 0 11.349 5.472 11.349 12.767Zm27.256 12.564h-7.498l-7.802-10.234-2.533 1.925v2.027h2.229v6.383h-11.652V31.23h2.228V8.938h-3.242V2.555h10.437v20.062l5.269-3.85h-3.242v-6.384h13.881v6.384h-2.229l-5.472 4.053 6.282 8.207h3.243c.101.102.101 6.384.101 6.384ZM190.53 22.415h8.207c0-3.547-2.33-4.965-3.952-4.965-2.025 0-4.153 1.62-4.255 4.965Zm-24.723 0h8.207c0-3.547-2.331-4.965-4.053-4.965-1.925.1-4.053 1.722-4.154 4.965Zm-121.693.101h8.208c0-3.546-2.33-4.965-4.053-4.965-2.027 0-4.054 1.621-4.155 4.965Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h235.122v40H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default NewsweekLogo;
